import React from 'react';
import PropTypes from 'prop-types';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import { isSuppressGuestCallUsLink } from '../../lib/covidHelper';

function btnLinkStyle() {
  let style = 'vx_btn-link login-bottom';
  if (Page.isNoExtraSpaceLocale()) {
    style += ' no_extra_space';
  }
  return style;
}

function isMessage(clickAction, linkAction, content) {
  if (content.login.message) {
    return (
      <div className="login-bottom">
        <span>{content.login.message}</span>
        <span><button onClick={() => linkAction()} role="link" className={btnLinkStyle()}>{content.login.guestMessage}</button></span>
      </div>
    );
  }
  return null;
}

function onPasswordRecoveryClick(channelType) {
  trackLink({ id: 'intermediatePage', link: `smarthelp-intermediate|password-recovery|${channelType}` });
  window.location.href = '/authflow/password-recovery';
}

// BCP COVID-19
function renderPasswordRecovery(content, loggedOutChatContent, channelType, isLoggedOutChatEnabled, loggedOutChatClickHandler, puiTopicClickHandler, isPuiTopicEnabled) {
  // If selected intent is enabled for logged out chat in RC

  if (isLoggedOutChatEnabled) {
    return (
      <div className="login-trouble-inst">
        <span className="login-trouble-inst--header">{content.login.trouble}</span>
        <a
          className="login-trouble-inst--rec_password"
          href="#password-recovery"
          role="link"
          onClick={() => onPasswordRecoveryClick(channelType)}
        >
          {loggedOutChatContent.recoverPassword}
        </a>
        <div className="login-trouble-inst--chat_link">
          <span className="login-trouble-inst--chat_link__chat_icon" />
          <a
            href="javascript:;"// eslint-disable-line jsx-a11y/no-static-element-interactions,no-script-url
            role="link"
            onClick={() => loggedOutChatClickHandler()}
          >
            {loggedOutChatContent.chatWithUs}
          </a>
        </div>

        <div className="login-trouble-inst--chat_message">
          <span className="login-trouble-inst--chat_message__description">{loggedOutChatContent.loggedOutChatText}</span>
        </div>
      </div>
    );
  }
  // Show logged out with email link  for paypui (pay upon invoice)topic (controlled from remote config )
  if (!isLoggedOutChatEnabled && isPuiTopicEnabled) {
    return (
      <div className="login-trouble-inst">
        <span className="login-trouble-inst--header">{content.login.trouble}</span>
        <a
          className="login-trouble-inst--rec_password"
          href="#password-recovery"
          role="link"
          onClick={() => onPasswordRecoveryClick(channelType)}
        >
          {loggedOutChatContent.recoverPassword}
        </a>
        <div id="test-LogIn-onPuiConfigEnabled" className="login-trouble-inst--chat_link">
          <a
            href="javascript:;"// eslint-disable-line jsx-a11y/no-static-element-interactions,no-script-url
            role="link"
            onClick={() => puiTopicClickHandler()}
          >
            {content.emailUs.emailWhileLoggedOut}

          </a>
        </div>
      </div>
    );
  }

  // Default
  return (
    <div>
      <a
        href="#password-recovery"
        role="link"
        onClick={() => onPasswordRecoveryClick(channelType)}
      >
        {content.login.trouble}
      </a>
    </div>
  );
}

const LogIn = ({
  content, channelType, clickAction, linkAction, isLoggedOutChatEnabled, loggedOutChatClickHandler, loggedOutChatContent, puiTopicClickHandler, isPuiTopicEnabled,

}) => (
  <div className="text-center">
    <div className="login-header">{content.login.header}</div>
    <div className="login">{content.login.loginMessage}</div>
    <button className="login_btn btn" onClick={() => clickAction()}>{content.login.login}</button>
    {renderPasswordRecovery(content, loggedOutChatContent, channelType, isLoggedOutChatEnabled, loggedOutChatClickHandler, puiTopicClickHandler, isPuiTopicEnabled)}
    <hr className="login-info-line" />
    {!isSuppressGuestCallUsLink() ? isMessage(clickAction, linkAction, content) : null}
    <div className="login-inst">
      <span className="cw_icon cw_icon-small cw_icon-attention-small user-attention-icon" aria-hidden="true" />
      <p className="instruction-info">{content.login.instruction}</p>
    </div>
  </div>

);

LogIn.propTypes = {
  content: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  channelType: PropTypes.string.isRequired,
  clickAction: PropTypes.func,
  linkAction: PropTypes.func,
  isLoggedOutChatEnabled: PropTypes.bool,
  loggedOutChatClickHandler: PropTypes.func,
  loggedOutChatContent: PropTypes.shape({}),
  isPuiTopicEnabled: PropTypes.bool,
  puiTopicClickHandler: PropTypes.func,

};

export default LogIn;
